"use client"

/**
 * ListPageHeader — shared header for every admin list page.
 *
 * See LIST_PAGES_SPEC.md for the full contract. Title + subtitle left,
 * primary action right. No chrome, sits directly on admin-background.
 */

import type { ReactNode } from "react"

interface ListPageHeaderProps {
  title: ReactNode
  subtitle?: ReactNode
  primaryAction?: ReactNode
  secondaryActions?: ReactNode
}

export function ListPageHeader({ title, subtitle, primaryAction, secondaryActions }: ListPageHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4 mb-4" style={{ minHeight: 40 }}>
      <div className="min-w-0">
        <h1
          className="m-0"
          style={{
            fontSize: 22,
            fontWeight: 600,
            color: "var(--admin-foreground)",
            lineHeight: 1.25,
            letterSpacing: "-0.01em",
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <div
            className="mt-1"
            style={{ fontSize: 13, color: "var(--admin-muted-fg)", fontWeight: 400 }}
          >
            {subtitle}
          </div>
        )}
      </div>
      {(primaryAction || secondaryActions) && (
        <div className="flex items-center gap-2 shrink-0">
          {secondaryActions}
          {primaryAction}
        </div>
      )}
    </div>
  )
}

export default ListPageHeader
